const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0244898,0,0,0.0244898,2.23061,0.192653)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M480.6,341.4C469.3,341.4 460.2,350.5 460.2,361.8L460.2,460.2L51.8,460.2L51.8,361.8C51.8,350.5 42.7,341.4 31.4,341.4C20.1,341.4 11,350.5 11,361.8L11,480.6C11,491.9 20.1,501 31.4,501L480.6,501C491.9,501 501,491.9 501,480.6L501,361.8C501,350.5 491.9,341.4 480.6,341.4Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241,365.6C252.5,377.2 266.6,370.8 270.9,365.6L388.2,239.4C395.9,231.1 395.4,218.2 387.1,210.5C378.8,202.8 365.9,203.3 358.3,211.6L276.4,299.7L276.4,34.5C276.4,23.2 267.3,14.1 256,14.1C244.7,14.1 235.6,23.2 235.6,34.5L235.6,299.8L153.7,211.7C146,203.4 133.1,203 124.8,210.6C116.5,218.3 116.1,231.2 123.7,239.5L241,365.6Z",
    style: {
      fill: "rgb(45, 169, 226)",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.c05c5dba1b1dba3ef1186ef40c8f92e2.svg";
export { ForwardRef as ReactComponent };